/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_NoneInputs */

const en_disabled_websites_none = /** @type {(inputs: Disabled_Websites_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disabled websites`)
};

const es_disabled_websites_none = /** @type {(inputs: Disabled_Websites_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay sitios deshabilitados`)
};

/**
* | output |
* | --- |
* | "No disabled websites" |
*
* @param {Disabled_Websites_NoneInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_none = /** @type {((inputs?: Disabled_Websites_NoneInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_NoneInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_none(inputs)
	return en_disabled_websites_none(inputs)
});